var map = {
	"./en/summary.json": [
		43462,
		3462
	],
	"./fr/summary.json": [
		96545,
		6545
	],
	"./nl/summary.json": [
		90979,
		979
	],
	"./zh/summary.json": [
		24491,
		4491
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27987;
module.exports = webpackAsyncContext;